import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { isCreate, isDelete, isExport, isUpdate, isView } from 'utils/verification.utils';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grid, InputAdornment } from "@mui/material";
import TemplateTypeApi from 'api/setting/treatment-templates/template-tpyes.api';
import TemplateApi from 'api/setting/treatment-templates/template.api';
import HeaderCard from "component/CardCustom/HeaderCard";
import { notiError, notiSuccess } from 'component/notifications/notifications';
import TableCustom from 'component/Table/TableCustom';
import TableRowCommon from 'component/Table/TableRowCommon';
import _ from 'lodash';
import MainButton from 'new-components/buttons/main-button';
import SelectInput from 'new-components/inputs/select-input';
import TextInput from "new-components/inputs/text-input";
import AlertModal from 'new-components/modal/alert-modal';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { routeName } from 'routes/routes-name';
import { getBranch } from 'utils/app.utils';

const permissions = {
    isCreate: isCreate(),
    isDelete: isDelete(),
    isUpdate: isUpdate(),
    isView: isView(),
    isExport: isExport()
}

export default function TreatmentTemplate() {
    const { t } = useTranslation()
    const history = useHistory()

    const [search, setSearch] = useState('')

    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [rowCount, setRowCount] = useState(0)
    const [sortBy, setSortBy] = useState('createAt')
    const [sortType, setSort] = useState('ASC')
    const [status, setStatus] = useState('ALL')
    const [templates, setTemplates] = useState<any>([])
    const [treatmentTemplateType, setTreatmentTemplateType] = useState<any>([])
    const [treatmentTemplateId, setTreatmentTemplateId] = useState<any>(0)
    const [appliedFilters, setAppliedFilters] = useState({
        search: '',
        status: '',
    })

    const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
    const [statusAlertModal, setStatusAlertModal] = useState('')
    const [id, setId] = useState<number>(0)
    const [name, setName] = useState('')

    const loadData = async () => {
        try {
            let condition = {}
            condition = {
                page: page,
                pageLimit: pageLimit,
                search: appliedFilters.search,
                sortBy: sortBy,
                sortType: sortType,
                status: appliedFilters.status === 'ALL' ? '' : appliedFilters.status,
                type: treatmentTemplateId === 0 ? '' : treatmentTemplateId
            }
            const resp = await TemplateApi.findAll(condition)
            if (resp.status === 200) {
                setRowCount(resp.headers['x-total'])
                setTemplates(resp.data)
            } else {
                setTemplates([])
            }
        } catch (error) {
            // notiError('ERROR')
        }
    }

    useEffect(() => {
        loadData()
    }, [page, pageLimit, sortBy, sortType, appliedFilters])

    const loadTemplateType = async () => {
        try {
            const resp: any = await TemplateTypeApi.findAll({ page: 1, pageLimit: 500 })
            if (resp.status === 200) {
                setTreatmentTemplateType(resp.data)
            } else {
                setTreatmentTemplateType([])
            }
        } catch (err) {
            notiError(t('ERROR'))
        }
    }

    useEffect(() => {
        loadTemplateType()
    }, [])

    const onRequestSort = (sortByVal: string, sort: string) => {
        setSort(sort)
        setSortBy(sortByVal)
    }

    const onActive = () => {
        if (id) {
            TemplateApi.updateStatus(id, statusAlertModal).then((resp) => {
                if (resp.status === 200) {
                    setIsOpenAlertModal(false)
                    notiSuccess(t('TREATMENT_TEMPLATE.MESSAGE.SUCCESS.UPDATE_STATUS'))
                    loadData()
                } else {
                    setIsOpenAlertModal(false)
                    notiError(t('TREATMENT_TEMPLATE.MESSAGE.ERROR'))
                }
            }).catch(() => {
                setIsOpenAlertModal(false)
                notiError(t('TREATMENT_TEMPLATE.MESSAGE.ERROR'))
            })
        }
    }

    const onDelete = () => {
        if (id) {
            TemplateApi.remove(id).then((resp) => {
                if (resp.status === 200) {
                    setIsOpenAlertModal(false)
                    notiSuccess(t('TREATMENT_TEMPLATE.MESSAGE.SUCCESS.DELETE'))
                    loadData()
                } else {
                    setIsOpenAlertModal(false)
                    notiError(t('TREATMENT_TEMPLATE.MESSAGE.ERROR'))
                }
            }).catch(() => {
                setIsOpenAlertModal(false)
                notiError(t('TREATMENT_TEMPLATE.MESSAGE.ERROR'))
            })
        }
    }

    const headlCells = [
        { id: 'no', disablePadding: false, label: t('TREATMENT_TEMPLATE.TABLE.NO') },
        { id: 'templateType', disablePadding: false, label: t('TREATMENT_TEMPLATE.TABLE.TEMPLATE_TYPE') },
        { id: 'templateId', disablePadding: false, label: t('TREATMENT_TEMPLATE.TABLE.TEMPLATE_CODE') },
        { id: 'templateName', disablePadding: false, label: t('TREATMENT_TEMPLATE.TABLE.TEMPLATE_NAME') },
        { id: 'templateNameEn', disablePadding: false, label: t('TREATMENT_TEMPLATE.TABLE.TEMPLATE_NAME_EN') },
        { id: 'branchCreate', disablePadding: false, label: t('TREATMENT_TEMPLATE.TABLE.BRANCH_CREATE') },
        { id: 'branchUse', disablePadding: false, label: t('TREATMENT_TEMPLATE.TABLE.BRANCH_USE') },
        { id: 'status', disablePadding: false, label: t('TREATMENT_TEMPLATE.TABLE.STATUS') },
        { id: 'updatedBy', disablePadding: false, label: t('TREATMENT_TEMPLATE.TABLE.UPDATED_BY') },
        { id: 'action', disablePadding: false, label: 'Action' }
    ]

    const renderData = (objData: any, no: number, valueExportData: boolean) => {
        const num = valueExportData === true ? no + 1 : page * pageLimit - pageLimit + no + 1
        const statusBtnActive = objData.status === 'ACTIVE' ? true : permissions.isUpdate.disabled
        const statusBtnInActive = objData.status === 'INACTIVE' ? true : permissions.isUpdate.disabled
        const branchCreate = _.find(objData?.treatmentTemplateBranches, (item) => item.isMain === "1") || "-"

        const disabledIsEdit = () => {
            const isMain = objData?.treatmentTemplateBranches.find((item: any) => item?.isMain === '1')
            if (isMain) {
                if (isMain?.branchId === getBranch()) {
                    return false
                } else {
                    return true
                }
            } else {
                return false
            }
        }
        const objRenderData = {
            key: objData?.treatmentTemplateId,
            id: objData?.treatmentTemplateId,
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: num },
                { option: 'TEXT', align: 'left', label: objData?.treatmentTemplateTypeName || "-" },
                { option: 'TEXT', align: 'left', label: objData?.treatmentTemplateCode || "-" },
                { option: 'TEXT', align: 'left', label: objData?.treatmentTemplateName || "-" },
                { option: 'TEXT', align: 'left', label: objData?.treatmentTemplateNameEn || "-" },
                { option: 'TEXT', align: 'left', label: branchCreate?.branchName },
                { option: 'TEXT', align: 'left', label: objData?.treatmentTemplateBranches?.map((item: any) => item.branchName).join(",") || "-" },
                { option: 'STATUS', align: 'center', label: objData?.status },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: objData?.updatedBy, updatedAt: objData?.updatedAt } },
                {
                    option: 'ACTION',
                    align: 'center',
                    label: 'action',
                    values: [
                        !disabledIsEdit() && { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
                        !disabledIsEdit() && { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
                        !disabledIsEdit() && { option: 'DIVIDER', label: '', disabled: false },
                        !disabledIsEdit() ? { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled } : { option: 'VIEW', label: t(`BUTTON.VIEW`) },
                        !disabledIsEdit() && { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
                    ]
                }
            ]
        }
        return (
            <TableRowCommon
                {...objRenderData}
                onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
                oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
                onedit={() => history.push(routeName.treatmentTemplate + '/update', objRenderData?.obj)}
                onView={() => history.push(routeName.treatmentTemplate + '/view', objRenderData?.obj)}
                ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
            />
        )
    }

    const handleSubmitModal = (id: number, status: string, obj?: any) => {
        setStatusAlertModal(status)
        setId(id)
        setIsOpenAlertModal(true)
        setName(obj.treatmentTemplateName)
    }

    return (
        <Box>
            <AlertModal
                isOpen={isOpenAlertModal}
                title={t(`TREATMENT_TEMPLATE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
                message={t(`TREATMENT_TEMPLATE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { treatmentTemplateName: name, status: t(`TREATMENT_TEMPLATE.ALERT.${statusAlertModal}`) })}
                type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
                handleClose={() => setIsOpenAlertModal(false)}
                onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
                onSubmit={{ onClick: () => statusAlertModal === 'DELETE' ? onDelete() : onActive(), title: t('BUTTON.SUBMIT') }}
            />
            <HeaderCard text={t('TREATMENT_TEMPLATE.TITLE')} />
            <Box paddingX="24px" paddingTop="16px">
                <Grid container spacing="16px">
                    <Grid item xs={12} sm={6} md={3} xl={2}>
                        <TextInput
                            label={t('TREATMENT_TEMPLATE.SEARCH')}
                            value={search}
                            onChange={(event) => {
                                setSearch(event.target.value)
                            }}
                            fullWidth
                            inputProps={{
                                endAdornment: (
                                    <InputAdornment position="end" >
                                        {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                onClick={() => {
                                                    setSearch('');
                                                }}
                                                style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} xl={2}>
                        <SelectInput
                            onChange={(event) => {
                                const value = event.target.value
                                setTreatmentTemplateId(value)
                            }}
                            options={[{ value: 0, name: t('ทั้งหมด') }, ...treatmentTemplateType.map((item: any) => ({ name: item.treatmentTemplateTypeName, value: item.treatmentTemplateTypeId }))]}
                            label={t('TREATMENT_TEMPLATE.TYPE_FILTER')}
                            value={treatmentTemplateId}
                            width="100%"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} xl={2}>
                        <SelectInput
                            onChange={(event) => {
                                const value = event.target.value
                                setStatus(value)
                            }}
                            options={[
                                { value: 'ALL', name: t('STATUS.ALL') },
                                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
                            ]}
                            label={t('STATUS.LABEL')}
                            value={status}
                            width="100%"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} xl={6}>
                        <Box display='flex' justifyContent='space-between' alignItems='center'>
                            <MainButton
                                title={t('INPUT.SEARCH')}
                                type='primary'
                                variant='contained'
                                style={{ width: '120px' }}
                                onClick={() => {
                                    setPage(1)
                                    setAppliedFilters({ search, status })
                                }}

                            />
                            <MainButton disabled={permissions.isCreate.disabled} title={t('TREATMENT_TEMPLATE.BUTTON.ADD')} type='primary' variant='contained' onClick={() => history.push(routeName.treatmentTemplate + '/create')} startIcon={<AddCircleIcon />} />
                        </Box>
                    </Grid>
                </Grid>


                <Box paddingTop="24px">
                    <TableCustom
                        page={page}
                        pageLimit={pageLimit}
                        sortType={sortType}
                        sortBy={sortBy}
                        onSort={onRequestSort}
                        setPageLimit={(limit: number) => setPageLimit(limit)}
                        setPage={(val: number) => {
                            setPage(val)
                        }}
                        rowCount={rowCount}
                        headCells={headlCells}
                        rowsData={templates.map((val: any, i: number) => {
                            return renderData(val, i, false)
                        })}
                    />
                </Box>
            </Box>
        </Box>
    )
}